<template>
  <v-card class="pa-2 mb-2" :to="{ name: 'OrderDetails', params: { id: orderPreview.id } }">
    <div class="d-flex">
      <avatar-image ref="avatar" :user="orderPreview.initiatorUser" :size="30" class="mr-1" />
      <div class="d-flex flex-column flex-grow-1">
        <template v-if="orderPreview.distributorNames.length === 0">
          <sf-heading ref="orderNumberTitle">
            {{ orderPreview.orderNumber }}
          </sf-heading>
          <sf-text v-if="orderPreview.sentDate" ref="sent-date">
            {{ formatDate(orderPreview.sentDate) }}
          </sf-text>
        </template>

        <template v-else>
          <sf-heading ref="distributors" class="align-self-start three-lines">
            {{ formatDistributors(orderPreview.distributorNames) }}
          </sf-heading>
          <div class="d-flex justify-space-between flex-wrap">
            <v-chip ref="orderNumberChip" size="small">
              {{ orderPreview.orderNumber }}
            </v-chip>
            <v-spacer />
            <sf-text v-if="orderPreview.sentDate" ref="sent-date">
              {{ formatDate(orderPreview.sentDate) }}
            </sf-text>
          </div>
        </template>
      </div>
    </div>

    <orders-grid-card-status
      :order-status="orderPreview.orderStatus"
      :is-topi="orderPreview.isTopiOrder"
      class="my-1"
    />

    <orders-grid-card-item v-for="(item, index) in orderPreview.items" :key="index" :item="item" />

    <v-divider class="my-1" />

    <div class="d-flex flex-column justify-space-between">
      <div ref="shippingCost" class="d-flex justify-space-between">
        <sf-text>{{ $t('shippingCostsShort') }}</sf-text>
        <span class="text-body-1 text-primary">
          {{ formatMoneyShowZeroPrice(orderPreview.shippingCost, false) }}
        </span>
      </div>
      <div ref="netSum" class="d-flex justify-space-between">
        <sf-heading>∑</sf-heading>
        <span class="text-body-1 font-weight-bold text-primary">
          {{ formatMoneyShowZeroPrice(orderSum, false) }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import AvatarImage from '@/components/AvatarImage.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import OrdersGridCardItem from '@/modules/order/components/OrdersGridCardItem.vue'
import OrdersGridCardStatus from '@/modules/order/components/OrdersGridCardStatus.vue'
import { formatDistributors } from '@/modules/order/helpers'
import usePortalSettings from '@/modules/portalSettings/usePortalSettings'
import { formatMoneyShowZeroPrice } from '@/modules/product/helpers'
import { OrderPreview } from '@/types/index'
import { formatDate } from '@/utils/timeFormatHelpers'
import { storeToRefs } from 'pinia'
import { computed, PropType } from 'vue'

const props = defineProps({
  orderPreview: {
    type: Object as PropType<OrderPreview>,
    required: true
  }
})
const { portalSettings } = storeToRefs(usePortalSettings())

const orderSum = computed(() => {
  return portalSettings.value.grossPortal
    ? props.orderPreview.orderSumInformation.grossSum
    : props.orderPreview.orderSumInformation.netSum
})
</script>
